var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-btn"},[_c('div',{staticClass:"btn-login",on:{"click":_vm.emitLogin}},[_vm._v("开启智慧会议")])])
}
var staticRenderFns = []

export { render, staticRenderFns }